import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NbCalendarRange } from "@nebular/theme";
import { CampaignFinance } from "../../../@core/data/campaignFinance";
import { CampaignFinanceService } from "../../../@core/api/campaignFinance.service";
import { ExportService } from "../../../@core/utils/export.service";


@Component({
  selector: "ngx-finance-campaign-export",
  templateUrl: "./finance-campaign-export.component.html",
  styleUrls: ["./finance-campaign-export.component.scss"],
})
export class FinanceCampaignExportComponent implements OnInit {
  id: string;
  campaign: CampaignFinance;
  campaignId: string;

  wantToMapFields: boolean = false;
  loading: boolean = true;
  timeFrame: string = "today";
  timeRange: {
    dateStart: number;
    dateEnd: number;
  };
  dateRange: NbCalendarRange<Date>;

  selectedPreset: any;
  presetName: any;
  savedPresets: any = [];
  wantToSavePreset: boolean = false;

  exportLeads: any;
  allLeadsKeys = [];
  fieldMap = [{ label: "", fields: [] }];

  constructor(
    public route: ActivatedRoute,
    public campaignService: CampaignFinanceService,
    public exportService: ExportService
  ) {
    this.id = this.route.snapshot.params["id"];
  }

  async ngOnInit() {
    await this.getDataCampaign();
    this.loading = false;
  }

  async getDataCampaign() {
    this.campaign = await this.campaignService.getCampaignFinance(this.id);
    this.savedPresets = await this.campaignService.getPresetsFinance(this.id);
    this.campaignId = this.id;
    //this.id = this.campaign.offer_id;
  }

  addField() {
    this.fieldMap.push({ label: "", fields: [] });
  }

  removeField(index) {
    this.fieldMap.splice(index, 1);
  }

  timeChanged() {
    let interval = 1000 * 60 * 60 * 24; // 24 hours in milliseconds
    let dateStart = Math.floor(Date.now() / interval) * interval;
    let dateEnd = Date.now();
    this.timeRange = { dateStart, dateEnd };

    switch (this.timeFrame) {
      case "today":
        interval = 1000 * 60 * 60 * 24; // 24 hours in milliseconds
        dateStart = Math.floor(Date.now() / interval) * interval;
        dateEnd = Date.now();
        this.timeRange = { dateStart, dateEnd };

        break;

      case "yesterday":
        interval = 1000 * 60 * 60 * 24; // 24 hours in milliseconds
        dateStart = Math.floor(Date.now() / interval) * interval - interval;
        dateEnd = Math.floor(Date.now() / interval) * interval;

        this.timeRange = { dateStart, dateEnd };

        break;

      case "week":
        let d = new Date();
        let day = d.getDay();
        let diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
        d.setDate(diff);
        dateStart = d.getTime();
        dateEnd = Date.now();
        dateStart += 1000 * 60 * 60;
        dateEnd += 1000 * 60 * 60;
        this.timeRange = { dateStart, dateEnd };

        break;

      case "month":
        let currentDate = new Date();
        dateEnd = Date.now();
        dateStart =
          (new Date(
            currentDate.getMonth() +
              1 +
              "-1-" +
              currentDate.getFullYear() +
              " 00:00"
          ).getTime() *
            1000) /
          1000;
        dateStart += 1000 * 60 * 60;
        dateEnd += 1000 * 60 * 60;
        this.timeRange = { dateStart, dateEnd };
        1;
        break;

      default:
        break;
    }

    if (this.timeFrame !== "personalized") {
      this.getData(dateStart, dateEnd);
    }
  }

  rangeChanged() {
    if (this.dateRange.end && this.dateRange.start) {
      let dateEnd =
        new Date(this.dateRange.end).getTime() + 24 * 60 * 60 * 1000;
      let dateStart = (new Date(this.dateRange.start).getTime() * 1000) / 1000;

      dateStart += 1000 * 60 * 60;
      dateEnd += 1000 * 60 * 60;
      this.getData(dateStart, dateEnd);
    }
  }

  loadPreset() {
    console.log(this.selectedPreset, this.savedPresets[this.selectedPreset]);
    if (this.selectedPreset == -1) {
      this.fieldMap = [{ label: "", fields: [] }];
    } else {
      this.fieldMap = this.savedPresets[this.selectedPreset].fields;
    }
  }

  async savePreset() {
    let preset = {
      fields: this.fieldMap,
      name: this.presetName,
      offer_id: this.campaignId,
    };

    await this.campaignService.createPresetFinance(preset);
    this.wantToSavePreset = false;
    this.presetName = "";
  }

  async getData(dateStart: number, dateEnd: number) {
    this.loading = true;
    this.exportLeads = await this.campaignService.exportCampaignFinanceId(
      dateStart,
      dateEnd,
      this.id
    );

    let keys = [];
    this.exportLeads.map((l) => {
      keys.push(...Object.keys(l));
    });

    this.allLeadsKeys = [...new Set(keys)];

    this.allLeadsKeys.sort();
    this.loading = false;
  }

  exportJson() {
    this.exportService.exportJson(this.campaign, this.exportLeads)
  }

  exportCSV() {
  const leadToCsv = [];

  // mappatura dei campi con le leads
  this.exportLeads.forEach((lead, index) => {
    const newLead = {};

    this.fieldMap.forEach((f) => {
        let rawValue = lead[f.fields[0]];
        let value = ''; // default
        switch (f.fields[0]) {
           case "birthday":
             value = rawValue ? this.exportService.extractBirthday(rawValue) : '';
             break;

           case "time":
           case "time_sent":
             value = rawValue ? this.exportService.convertUnixToDate(rawValue) : '';
             break;

           case "response":
             try {
               value = rawValue ? this.exportService.flattenData(rawValue) : '';
             } catch {
               value = rawValue || '';
             }
             break;

           case "id":
           case "ref_id":
             value = rawValue ? `​${rawValue}` : '';
             break;

           case "address":
           case "hometown":
             value = this.exportService.extractAddressField(f.label, rawValue);
             break;

           default:
             value = typeof rawValue !== 'undefined' && rawValue !== null ? rawValue : '';
        }
        if(f.label == "nazioneResidenza"){ value = "ITALIA"}
        if(f.label == "telefono"){ 
          value = lead.phone? lead.phone : lead.phone_number;
          value = this.exportService.formatPhoneForCSV(value);
        }

        newLead[f.label] = value;
    });

    leadToCsv.push(newLead);
  });

  const headerList = this.fieldMap.map(field => field.label);
  const filename = `${this.campaign.name}_${Date.now()}.csv`;
  const csvData = this.exportService.convertToCSV(leadToCsv, headerList)

  this.exportService.downloadFile(csvData, filename, "text/csv;charset=utf-8");
}

}


